var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 72.3181C56.5057 72.3181 72.3182 56.5056 72.3182 36.9999C72.3182 17.4943 56.5057 1.68176 37 1.68176C17.4943 1.68176 1.68182 17.4943 1.68182 36.9999C1.68182 56.5056 17.4943 72.3181 37 72.3181Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_1971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 72,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72.3181C56.5057 72.3181 72.3182 56.5056 72.3182 36.9999C72.3182 17.4943 56.5057 1.68176 37 1.68176C17.4943 1.68176 1.68182 17.4943 1.68182 36.9999C1.68182 56.5056 17.4943 72.3181 37 72.3181Z",
    fill: "#DBDBDB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_1971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2467 72.419L48.9881 72.1365L53.0245 69.9367L57.2627 66.0685C58.265 56.657 52.5065 44.7565 52.5065 44.7565L42.5636 37.0874H33.5221L21.6485 44.7565C21.6485 44.7565 15.89 56.5427 16.8923 65.9541L17.9821 68.0799L25.0794 71.2687L36.2399 72.419",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.434 16.1521C47.434 16.1521 34.4638 13.3468 27.7298 16.1184C27.7298 16.1184 11.7458 16.771 10.0035 28.9204C10.0035 28.9204 14.5377 36.973 17.3833 37.4641C20.2289 37.9552 19.4284 40.4039 19.4284 40.4039L22.2404 45.9875L36.8722 52.2641L51.4838 45.4561L54.316 38.7624L64.1715 28.7321C64.1715 28.7321 60.7675 17.8406 47.4408 16.1521H47.434Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8655 14.8605C36.8655 14.8605 30.4947 14.4838 27.7231 16.1185C27.4675 16.2732 26.5996 16.1252 26.2969 16.1521C25.012 16.253 23.7338 16.5087 22.496 16.8854C18.1636 18.1838 14.3964 20.915 11.4633 24.319C9.74783 26.3103 9.06837 28.4294 10.9924 30.5889C11.7458 31.5038 12.4993 32.4254 13.2595 33.3403C14.9413 35.3854 18.6211 40.3098 21.5609 37.0067C21.5609 37.0067 24.9784 33.9861 26.5391 28.9541",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4217 38.7692C19.6033 40.4846 20.2491 42.1933 21.1842 43.6397C23.6531 47.4406 28.3286 48.6381 32.5937 48.9475C40.7875 49.5395 53.3204 49.4521 54.3026 38.7759",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4453 36.0245C30.4596 36.0245 31.2818 35.2023 31.2818 34.188C31.2818 33.1737 30.4596 32.3514 29.4453 32.3514C28.431 32.3514 27.6087 33.1737 27.6087 34.188C27.6087 35.2023 28.431 36.0245 29.4453 36.0245Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1995 38.85L34.8002 37.4507C34.2755 36.926 34.6455 36.0178 35.3922 36.0178H38.3455C39.0922 36.0178 39.4689 36.9193 38.9375 37.4507L37.5382 38.85C37.1682 39.22 36.5695 39.22 36.1995 38.85Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6031 39.3612V41.5879C33.966 43.5792 32.3851 40.6461 32.3851 40.6461",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8655 14.8605C36.8655 14.8605 43.2362 14.4838 46.0078 16.1185C46.2635 16.2732 47.1313 16.1252 47.434 16.1521C48.7189 16.253 49.9971 16.5087 51.2349 16.8854C55.5673 18.1838 59.3346 20.915 62.2677 24.319C63.9831 26.3103 64.6626 28.4294 62.7386 30.5889L60.4715 33.3403C58.7897 35.3854 55.1098 40.3098 52.17 37.0067C52.17 37.0067 48.7526 33.9861 47.1918 28.9541",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2856 36.0245C45.2999 36.0245 46.1222 35.2023 46.1222 34.188C46.1222 33.1737 45.2999 32.3514 44.2856 32.3514C43.2713 32.3514 42.4491 33.1737 42.4491 34.188C42.4491 35.2023 43.2713 36.0245 44.2856 36.0245Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3526 40.6461C41.3526 40.6461 39.7716 43.5792 37.1346 41.5879V39.3612",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72.3181C56.5057 72.3181 72.3182 56.5056 72.3182 36.9999C72.3182 17.4943 56.5057 1.68176 37 1.68176C17.4943 1.68176 1.68182 17.4943 1.68182 36.9999C1.68182 56.5056 17.4943 72.3181 37 72.3181Z",
    stroke: "#DBDBDB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profile-img.03d3b661db0d677c4e05e76aa73b4e67.svg";
export { ForwardRef as ReactComponent };